import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { bookingListing, deleteBooking, viewBooking } from "../apis/apiHandler";

export const allBookings = createAsyncThunk(
    'booking/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await bookingListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewBookingDetails = createAsyncThunk(
    'booking/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewBooking(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteBookings = createAsyncThunk(
    'booking/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteBooking(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    bookingList: [],
    error: null,
    bookingDetail: {},
    deleteSuccess: false,
    statusSuccess: false
};

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allBookings.pending, (state) => {
                state.loading = true;
            })
            .addCase(allBookings.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.bookingList = payload?.data;
            })
            .addCase(allBookings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(viewBookingDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewBookingDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.bookingDetail = payload?.data;
            })
            .addCase(viewBookingDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBookings.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteBookings.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteBookings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
    }
})

export default bookingSlice.reducer;